<template>
  <b-card no-body class="position-relative bg-white mb-2 hover">
    <b-card-body class="px-2 pt-2 pb-1">
      <b-row class="row">
        <b-col>
          <b-row align-v="center" no-gutters class="gx-2 gy-0 m-0">
            <b-col>
              <p class="lh-sm m-0">
                <span class="fw-bold">
                  <a href="#" class="link-primary stretched-link">
                    {{ title }}
                  </a>
                </span>
              </p>
            </b-col>
          </b-row>
          <b-row align-v="center" no-gutters class="gx-2 gy-0 m-0">
            <b-col cols="auto">
              <span class="fs-6 fw-bold position-relative z-3"
                    v-b-tooltip.hover title="Die Bewerber:innen-ID in dieser Plattform.">
                ID: {{ id }}
              </span>
            </b-col>
            <b-col cols="auto">
              <span class="position-relative z-3" v-b-tooltip.hover :title="`Sucht Stellenangebote in ${location}`">
                <b-icon icon="geo-alt" class="fs-6 mr-1"></b-icon>
                <span class="fs-6">{{ location }}</span>
              </span>
            </b-col>
          </b-row>
        </b-col>
        <div class="col-auto">
          <b-button @click="deleteNotepad" variant="primary" size="sm" class="position-relative z-3"  v-b-tooltip.hover title="dieses Profil aus dem Notizbuch löschen">
            <b-icon icon="trash" scale="0.9"></b-icon>
          </b-button>
        </div>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NotebookCompanyItem extends Vue {
  @Prop({ default: 0 }) private id!: number;

  @Prop({ default: '' }) private title!: string;

  @Prop({ default: '' }) private location!: string;

  async deleteNotepad() {
    this.$emit('delete');
  }
}
</script>
<style scoped lang="scss"></style>
